<template>
    <div class="page">
        <div class="player-item">
            <div id='player' @click="wholeFullScreen"></div>
            <!-- <img class="icon" src="./../assets/bigvideo_icon@2x.png" alt="" @click="getData" v-if="showPlayIcon"> -->
        </div>
        <div class="infoBox">
			<div class="info">
                <div class="title">{{ title }}</div>
			</div>
		</div>
        <!-- <input type="text" v-model="url">
        <div @click="getData">刷新</div> -->
    </div>
</template>

<script>
    import Apis from '../config/apis'
    export default {
        data () {
            return {
                player: null,
                // url: 'ws://220.176.1.74:559/openUrl/Wqz6me4',
                url: '',
                splitNum: 1,
                mode: 0,
                title: '慢直播',
                sid: '',
                code: '',
                showPlayIcon: true,
            }
        },
        mounted() {
            document.getElementById('index-loading-box').className = 'index-loading-box hide'

            this.sid = this.$route.query.sid
            this.code = this.$route.query.code
            if(this.$route.query.title) this.title = this.$route.query.title

            document.title = this.title
            
            this.createPlayer()
            // this.getData()
        },
        methods: {
            getData() {
                this.showPlayIcon = false
                this.axios.post(Apis.otherHaikangCamera, {
                    sid: this.sid,
                    code: this.code,
                }).then((res) => {
                    this.url = res.data.url
                    this.$nextTick(() => {
                        // this.url = 'ws://220.176.1.74:559/openUrl/YZsboEE'
                        this.realplay()
                    })
                })
            },

            createPlayer () {
                this.player = new window.JSPlugin({
                    szId: 'player',
                    // szBasePath: '../config',
                    szBasePath: '/h5-player/',
                    iMaxSplit: 16,
                    iCurrentSplit: this.splitNum,
                    openDebug: true,
                    oStyle: {
                        borderSelect: '#000'
                    }
                })
                // let that = this
                this.player.JS_SetWindowControlCallback({
                    windowEventSelect (iWndIndex) {
                        console.log('windowSelect callback: ', iWndIndex)
                        // eslint-disable-next-line
                        // $('.parent-wnd').children().eq(iWndIndex).css('border','1px solid rgb(255, 204, 0)')
                        // that.handleOpen()
                    },
                    pluginErrorHandler: function (iWndIndex, iErrorCode, oError) {
                        console.log('pluginError callback: ', iWndIndex, iErrorCode, oError)
                    },
                    windowEventOver: function (iWndIndex) {
                    },
                    windowEventOut: function (iWndIndex) {
                    },
                    windowEventUp: function (iWndIndex) {
                    },
                    windowFullCcreenChange: function (bFull) {
                    console.log('fullScreen callback: ', bFull)
                    },
                    firstFrameDisplay: function (iWndIndex, iWidth, iHeight) {
                    console.log('firstFrame loaded callback: ', iWndIndex, iWidth, iHeight)
                    },
                    performanceLack: function () {
                    console.log('performanceLack callback: ')
                    }
                })

                this.getData()
            },
            
            arrangeWindow () {
                const splitNum = this.splitNum
                this.player.JS_ArrangeWindow(splitNum).then(
                () => { console.log(`arrangeWindow to ${splitNum}x${splitNum} success`) },
                    e => { console.error(e) }
                )
            },
            realplay () {
                // this.mode = 1  //解码方式：0普通模式 1高级模式
                const { player, mode, url } = this,

                index = player.currentWindowIndex,
                playURL = url
                // playURL = this.realplay

                player.JS_Play(playURL, { playURL, mode }, index).then(
                () => {
                    console.log('realplay success')
                },
                e => { console.error('realplay fail', e) }
                )
            },
            
            wholeFullScreen () {
                this.player.JS_FullScreenDisplay(true).then(
                    () => { console.log(`wholeFullScreen success`) },
                    e => { console.error(e) }
                )
            },
        }
    }
</script>

<style lang="scss" scoped>
.page {
    min-height: 100vh;
	background-color: #ffffff;
    padding-bottom: 1rem;
    box-sizing: border-box;
    text-align: left;
    .player-item {
        position: relative;
        width: 100%;
        height: 4.66rem !important;
        #player {
            width: inherit;
            height: inherit;
        }
        .icon {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: .40rem;
            height: .40rem;
            padding: .20rem;
            background: #858585;
            box-sizing: content-box;
            border-radius: 50%;
        }
    }
    .infoBox{
        width: 6.9rem;
        margin: .3rem;
        display: flex;
        position: relative;
        .info{
            position: relative;
            // margin-left: .2rem;
            flex: 1;
            .title{
                font-size: .36rem;
                font-weight: bold;
                color: #333333;
                // line-height: 50rpx;
                line-height: 1.2;
            }
            .list{
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: .26rem;
                font-weight: 400;
                color: #333333;
                margin-top: .3rem;
                line-height: 1.2;
                .left{
                    flex: 1;
                }
            }
            .bottom {
                position: absolute;
                bottom: .14rem;
            }
            .bottom1 {
                position: absolute;
                bottom: .4rem;
            }
        }
    }
}
</style>